import React from "react"
import { Form } from "react-bootstrap"

export default function UnitaryAuthSelect({
  value,
  setField,
  field,
  required = false,
  classes,
}) {
  return (
    <Form.Group className={`mb-1 ${classes}`}>
      <Form.Label>Unitary Authority</Form.Label>
      <Form.Select
        value={value ?? ""}
        required={required}
        onChange={(e) => setField(field, e.target.value)}
      >
        <option value="">All authorities</option>
        <option value="Cumberland">Cumberland</option>
        <option value="Cumbria Wide">Cumbria Wide</option>
        <option value="Outside Cumbria">Outside Cumbria</option>

        <option value="Westmorland & Furness">Westmorland & Furness</option>
      </Form.Select>
    </Form.Group>
  )
}
